var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 8,
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4122 2.58885C12.3985 3.66843 13.3743 4.27091 14.1094 4.62909C14.8647 4.99664 15.1184 5.2323 15.1155 5.56093C15.1097 6.06396 14.513 6.28593 13.9545 6.29458C12.9801 6.30971 12.4137 6.03153 11.9632 5.82109L11.6123 7.46351C12.0641 7.67179 12.9008 7.8534 13.7685 7.86133C15.8052 7.86133 17.1377 6.85598 17.1449 5.29716C17.1528 3.3189 14.4085 3.20935 14.4272 2.32508C14.4337 2.05699 14.6896 1.77088 15.2503 1.69809C15.5277 1.66134 16.2938 1.63323 17.1622 2.03321L17.5031 0.444116C17.0361 0.274035 16.4358 0.111163 15.6884 0.111163C13.7714 0.111163 12.423 1.1302 12.4122 2.58885ZM20.7786 0.248091C20.4067 0.248091 20.0932 0.465015 19.9534 0.797968L17.044 7.74458H19.0792L19.4842 6.62537H21.9713L22.2062 7.74458H24L22.4347 0.248091H20.7786ZM21.0632 2.27319L21.6506 5.08816H20.042L21.0632 2.27319ZM9.94463 0.248091L8.3404 7.74458H10.2797L11.8833 0.248091H9.94463ZM7.07561 0.248091L5.05699 5.35049L4.24047 1.01201C4.14462 0.527714 3.76626 0.248091 3.34611 0.248091H0.0461234L0 0.465735C0.677437 0.612754 1.44712 0.849857 1.9134 1.10354C2.19879 1.25848 2.28022 1.39397 2.37391 1.76223L3.92049 7.74458H5.97009L9.11225 0.248091H7.07561Z",
    fill: "url(#paint0_linear_2611_3232)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2611_3232",
    x1: 1103.38,
    y1: 23.4095,
    x2: 1125.81,
    y2: -772.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.61c252f64a2e32264a0dac88a8cdf3bf.svg";
export { ForwardRef as ReactComponent };